module.exports = __webpack_public_path__ + "img/submitSuccess.91dcae88.png";